// CH-4396: Services classified as Onsite. Everything else is treated as Offsite.
//
// NOTE: duplicated in cms2 (cms2/src/enums/onsiteServiceTypes.js) — update both together.
//
// We hardcode this instead of using the API's `Service.OnSite` flag because that
// flag disagrees with the required classification: it marks Copywriting Brief,
// 3D Interactive Floorplan, Photography R Direct and Floorplan - External as
// Onsite (they must be Offsite), and marks the Companion services / Drone
// Companion Photography as Offsite (they must be Onsite).
//
// Keys match on the current service name; older names are kept as aliases for
// environments that haven't run the rename seeds yet:
//   Matterport -> Virtual Tour
//   Companion Matterport -> Companion Virtual Tour
//   Property Photography with Pole -> Super Bundle
const onsiteServiceTypes = [
  'Photography',
  'Dusk Photography',
  'Floorplan',
  'Copywriting',
  'Video',
  'Photography - Portrait',
  'Photography 2',
  'Dusk Photography 2',
  'Floorplan 2',
  'Photography - Portrait 2',
  'Copywriting 2',
  'Video Package',
  'Companion Floorplan',
  'Drone Photography',
  'Drone Videography',
  'Property Video - Agent Hype',
  'Drone Photography Budget',
  'Drone Companion Photography',
  'Photography - Twilight',
  'Photography - Eco',
  'Drone Video Premium',
  'Photography DIGI',
  'Floorplan DIGI',
  'Matterport',
  'Virtual Tour',
  'Photography - BW',
  'Interactive Virtual Tour - Standalone',
  'Companion Video',
  'Companion Matterport',
  'Companion Virtual Tour',
  'Companion Photography',
  'Companion Drone Videography',
  'Companion Drone Photography',
  'Photography Image Selector',
  'Content Direct Gallery',
  'Photography with Companion',
  'Property Photography with Companion',
  'Floorplan with Companion',
  'Prestige Photography with Companion',
  'Dusk Photography with Companion',
  'Content Direct Gallery One Provider',
  'Video Prestige',
  'Property Photography with Pole',
  'Super Bundle',
  'Photography Rental',
  'Photography Rental 2',
  'Photography with Companion Rental',
  'Property Photography Dusk with Pole',
  'Property Photography with Companion Rental',
  'Video Walkthrough',
]

// DB service names can carry stray/duplicate whitespace (e.g. "Companion  Virtual
// Tour" has an extra space in the DB), so collapse all whitespace before matching.
const normalize = (name) => String(name || '').trim().replace(/\s+/g, ' ').toLowerCase()

const onsiteServiceTypeNames = new Set(onsiteServiceTypes.map(normalize))

export const isOnsite = (service) => onsiteServiceTypeNames.has(normalize(service?.name))

export default onsiteServiceTypes
